var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 9.273V6.545a.905.905 0 00-.9-.909h-1.8v.91a.905.905 0 01-.9.909.905.905 0 01-.9-.91v-.909H9.3v.91a.905.905 0 01-.9.909.905.905 0 01-.9-.91v-.909H5.7c-.497 0-.9.407-.9.91v2.727h14.4zm0 1.818H4.8v8.182c0 .502.403.909.9.909h12.6c.497 0 .9-.407.9-.91v-8.181zM9.3 3.818h5.4V2.91c0-.502.403-.909.9-.909s.9.407.9.91v.908h1.8c1.491 0 2.7 1.221 2.7 2.727v12.728C21 20.779 19.791 22 18.3 22H5.7C4.209 22 3 20.779 3 19.273V6.545C3 5.04 4.209 3.818 5.7 3.818h1.8V2.91c0-.502.403-.909.9-.909s.9.407.9.91v.908z"
  })));
};

export default SvgCalendar;